(() => {
  var STORAGE_KEY = 'at_favorites';

  var BOOKMARK_ICON = '<svg width="19" height="22" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2C2 1.44772 2.44772 1 3 1H13C13.5523 1 14 1.44772 14 2V18.5L8 14.5L2 18.5V2Z" stroke="currentColor" stroke-width="0.9" stroke-linejoin="round"/></svg>';

  var isEN = (typeof Shopify !== 'undefined' && Shopify.locale === 'en')
    || document.documentElement.lang.startsWith('en')
    || window.location.pathname.startsWith('/en');

  var T = isEN ? {
    headerLabel: 'Saved products',
    headerText: 'Favorites',
    saveLabel: 'Save product',
    removeLabel: 'Remove',
    pricePrefix: 'From '
  } : {
    headerLabel: 'Opgeslagen producten',
    headerText: 'Favorieten',
    saveLabel: 'Bewaar product',
    removeLabel: 'Verwijder',
    pricePrefix: 'Vanaf '
  };

  var CLOSE_ICON = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isSaved(handle) {
    return load().some(function(i) { return i.handle === handle; });
  }

  function toggle(item) {
    var items = load();
    var idx = items.findIndex(function(i) { return i.handle === item.handle; });
    if (idx >= 0) items.splice(idx, 1);
    else items.unshift(item);
    save(items);
    return idx < 0;
  }

  function remove(handle) {
    save(load().filter(function(i) { return i.handle !== handle; }));
  }

  // ── Drawer ──────────────────────────────────────────

  var drawer = document.getElementById('favorites-drawer');
  var overlay = document.getElementById('favorites-overlay');
  var closeBtn = document.getElementById('favorites-close');
  var continueBtn = document.getElementById('favorites-continue');
  var listEl = document.getElementById('favorites-list');
  var emptyEl = document.getElementById('favorites-empty');
  var countEl = document.getElementById('favorites-count');

  function openDrawer() {
    renderDrawer();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  function formatPrice(cents) {
    return T.pricePrefix + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderDrawer() {
    var items = load();
    countEl.textContent = items.length ? '(' + items.length + ')' : '';
    emptyEl.style.display = items.length ? 'none' : '';
    listEl.innerHTML = '';

    items.forEach(function(item) {
      var li = document.createElement('li');
      li.className = 'favorites-item';

      var imgHtml = item.image
        ? '<a href="' + item.url + '"><img class="favorites-item__image" src="' + item.image + '" alt="' + item.title + '" width="80" height="80" loading="lazy"></a>'
        : '<a href="' + item.url + '"><div class="favorites-item__image favorites-item__image--placeholder"></div></a>';

      li.innerHTML = imgHtml
        + '<div class="favorites-item__info">'
        + '<a href="' + item.url + '" class="favorites-item__title">' + item.title + '</a>'
        + (item.price ? '<span class="favorites-item__price">' + formatPrice(item.price) + '</span>' : '')
        + '</div>'
        + '<button class="favorites-item__remove" data-handle="' + item.handle + '" aria-label="' + T.removeLabel + '">' + CLOSE_ICON + '</button>';

      listEl.appendChild(li);
    });

    listEl.querySelectorAll('.favorites-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        remove(btn.dataset.handle);
        updateAllBookmarks();
        updateHeaderBadge();
        renderDrawer();
      });
    });
  }

  // ── Header knop ─────────────────────────────────────

  function injectHeaderButton() {
    if (document.getElementById('fav-header-btn')) return;
    var headerIcons = document.querySelector('.header__icons') || document.querySelector('.header__action-wrapper');
    if (!headerIcons) return;

    var btn = document.createElement('button');
    btn.id = 'fav-header-btn';
    btn.className = 'fav-header-btn';
    btn.setAttribute('aria-label', T.headerLabel);
    btn.innerHTML = '<span class="fav-header-btn__text">' + T.headerText + '</span><span class="fav-header-btn__icon">' + BOOKMARK_ICON + '</span><span class="fav-header-btn__badge" id="fav-header-badge"></span>';
    btn.addEventListener('click', openDrawer);
    headerIcons.prepend(btn);
    updateHeaderBadge();
  }

  function updateHeaderBadge() {
    var badge = document.getElementById('fav-header-badge');
    if (!badge) return;
    var count = load().length;
    var isMobile = window.innerWidth <= 749;
    badge.textContent = count ? (isMobile ? String(count) : '(' + count + ')') : '';
    badge.classList.toggle('visible', count > 0);
  }

  // ── Bookmark knoppen op productkaarten ──────────────

  function buildItemFromCard(card) {
    var linkEl = card.querySelector('a[href*="/products/"]');
    if (!linkEl) return null;

    var url = linkEl.getAttribute('href');
    var parts = url.split('/products/');
    if (parts.length < 2) return null;
    var handle = parts[1].split('?')[0];
    if (!handle) return null;

    var titleEl = card.querySelector('.card__heading') || card.querySelector('h3');
    var title = titleEl ? titleEl.textContent.trim() : handle;

    var img = card.querySelector('img');
    var image = img ? img.src : null;

    var priceEl = card.querySelector('.price-item--regular') || card.querySelector('.price-item');
    var price = null;
    if (priceEl) {
      var raw = priceEl.textContent.replace(/[^0-9,]/g, '').replace(',', '.');
      price = Math.round(parseFloat(raw) * 100) || null;
    }

    return { handle: handle, title: title, url: url, image: image, price: price };
  }

  function findVisibleInfoEl(card) {
    var candidates = card.querySelectorAll('.card-information, .card-information__wrapper, .card__info-wrapper, [class*="card-info"]');
    for (var i = 0; i < candidates.length; i++) {
      var rect = candidates[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return candidates[i];
    }
    var priceEl = card.querySelector('.price-item--regular, .price-item, .price');
    if (priceEl) {
      var parent = priceEl.parentElement;
      while (parent && parent !== card) {
        var r = parent.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) return parent;
        parent = parent.parentElement;
      }
    }
    return card;
  }

  function injectBookmarkBtn(card) {
    if (card.querySelector('.fav-btn')) return;
    var item = buildItemFromCard(card);
    if (!item) return;

    requestAnimationFrame(function() {
      if (card.querySelector('.fav-btn')) return;

      var infoEl = findVisibleInfoEl(card);

      var btn = document.createElement('button');
      btn.className = 'fav-btn';
      btn.setAttribute('aria-label', T.saveLabel);
      btn.dataset.handle = item.handle;
      btn.innerHTML = BOOKMARK_ICON;

      if (isSaved(item.handle)) btn.classList.add('is-saved');

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var saved = toggle(item);
        btn.classList.toggle('is-saved', saved);
        updateAllBookmarks();
        updateHeaderBadge();
        if (saved) openDrawer();
      });

      // Prepend zodat float:right werkt vóór de heading
      infoEl.insertBefore(btn, infoEl.firstChild);
    });
  }

  function updateAllBookmarks() {
    document.querySelectorAll('.fav-btn').forEach(function(btn) {
      btn.classList.toggle('is-saved', isSaved(btn.dataset.handle));
    });
  }

  function scanCards() {
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      if (card.querySelector('a[href*="/products/"]')) injectBookmarkBtn(card);
    });
  }

  // ── Init ─────────────────────────────────────────────

  function init() {
    injectHeaderButton();
    scanCards();
    var observer = new MutationObserver(scanCards);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
